import React from 'react';

interface PhoneProps {
  size?: string | number;
  fill?: string;
}

const Phone = ({ size = '20', fill = '#231F20' }: PhoneProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="mask0_135_59496" maskUnits="userSpaceOnUse" x="0" y="0" width={size} height={size}>
        <rect width={size} height={size} fill="#D9D9D9" />
      </mask>
      <g>
        <path
          d="M18.681 19.9168C16.4823 19.9168 14.2735 19.4056 12.0546 18.3833C9.83572 17.3609 7.79519 15.9187 5.93301 14.0565C4.07832 12.1943 2.63981 10.1557 1.61748 7.94053C0.59515 5.72536 0.0839844 3.51843 0.0839844 1.31973C0.0839844 0.969726 0.200651 0.676192 0.433984 0.439125C0.667318 0.202039 0.958984 0.0834961 1.30898 0.0834961H5.11407C5.40873 0.0834961 5.66861 0.179601 5.89372 0.371809C6.11883 0.564017 6.26204 0.801464 6.32335 1.08415L6.99194 4.5168C7.03831 4.8354 7.02859 5.10912 6.96277 5.33796C6.89697 5.5668 6.7788 5.759 6.60828 5.91456L3.91374 8.53731C4.34751 9.33154 4.84297 10.0828 5.40014 10.791C5.9573 11.4992 6.56044 12.1757 7.20958 12.8203C7.84977 13.4605 8.53033 14.0551 9.25127 14.604C9.97221 15.1529 10.7507 15.6637 11.5869 16.1364L14.2051 13.4957C14.3876 13.3057 14.6086 13.1726 14.8681 13.0963C15.1276 13.02 15.3972 13.0013 15.6769 13.0402L18.9166 13.6998C19.2113 13.7776 19.4517 13.9279 19.6379 14.1508C19.8242 14.3737 19.9173 14.6264 19.9173 14.9091V18.6918C19.9173 19.0418 19.7987 19.3334 19.5616 19.5668C19.3246 19.8001 19.031 19.9168 18.681 19.9168Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};

export default Phone;
